/** Shared layout tokens for admin list + form tabs (aligned with News). */

export const adminListSectionClass =
  "min-h-0 min-w-0 flex-1 rounded-xl border border-brand-gray bg-white p-4 shadow-sm lg:max-w-[50%]";

export const adminFormSectionClass =
  "min-w-0 flex-1 rounded-xl border border-brand-gray bg-white p-4 shadow-sm lg:max-w-[50%]";

/** Single-column form (e.g. scoped branch/batch/association editor). */
export const adminScopedFormSectionClass =
  "mt-6 max-w-xl rounded-xl border border-brand-gray bg-white p-4 shadow-sm";

export const adminAddNewSecondaryButtonClass =
  "shrink-0 rounded-full border border-brand-maroon bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-brand-maroon transition hover:bg-brand-maroon/10 disabled:cursor-not-allowed disabled:border-brand-gray disabled:text-brand-blue/35 disabled:hover:bg-transparent";
